import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { MicroscopeIcon, DatabaseIcon, FactoryIcon, StethoscopeIcon, LayersIcon } from 'lucide-react';
export function FragmentedVsIntegrated() {
  const items = [{
    icon: MicroscopeIcon,
    label: 'Imaging'
  }, {
    icon: DatabaseIcon,
    label: 'Disease models'
  }, {
    icon: FactoryIcon,
    label: 'Manufacturing'
  }, {
    icon: StethoscopeIcon,
    label: 'Clinical trans.'
  }];
  return <div className="w-full py-4 flex flex-col space-y-6" data-id="element-53">
      <div className="grid grid-cols-2 gap-4" data-id="element-54">
        {/* Left: Fragmented */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5
      }} className="bg-white/5 border border-white/10 rounded-xl p-4 flex flex-col items-center relative h-48" data-id="element-55">
          <span className="text-[10px] font-medium text-slate-500 uppercase tracking-wider mb-2" data-id="element-56">
            Fragmented
          </span>

          <div className="relative w-full h-full" data-id="element-57">
            {/* Messy SVG Lines */}
            <svg className="absolute inset-0 w-full h-full opacity-20 pointer-events-none" style={{
            zIndex: 0
          }} data-id="element-58">
              <path d="M 20 20 Q 50 10 80 40 T 40 80" fill="none" stroke="white" strokeWidth="1" strokeDasharray="2 2" data-id="element-59" />
              <path d="M 80 20 Q 20 50 60 90" fill="none" stroke="white" strokeWidth="1" strokeDasharray="2 2" data-id="element-60" />
            </svg>

            {/* Scattered Icons */}
            <motion.div className="absolute top-2 left-2 p-1.5 bg-slate-800 rounded border border-slate-700 text-slate-400 z-10" data-id="element-61">
              <MicroscopeIcon className="w-4 h-4" data-id="element-62" />
            </motion.div>
            <motion.div className="absolute top-8 right-2 p-1.5 bg-slate-800 rounded border border-slate-700 text-slate-400 z-10" data-id="element-63">
              <DatabaseIcon className="w-4 h-4" data-id="element-64" />
            </motion.div>
            <motion.div className="absolute bottom-8 left-4 p-1.5 bg-slate-800 rounded border border-slate-700 text-slate-400 z-10" data-id="element-65">
              <FactoryIcon className="w-4 h-4" data-id="element-66" />
            </motion.div>
            <motion.div className="absolute bottom-2 right-4 p-1.5 bg-slate-800 rounded border border-slate-700 text-slate-400 z-10" data-id="element-67">
              <StethoscopeIcon className="w-4 h-4" data-id="element-68" />
            </motion.div>
          </div>
        </motion.div>

        {/* Right: Integrated */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.8,
        duration: 0.5
      }} className="bg-[#4B9FE1]/10 border border-[#4B9FE1]/30 rounded-xl p-4 flex flex-col items-center relative h-48 overflow-hidden" data-id="element-69">
          <div className="absolute inset-0 bg-gradient-to-br from-[#4B9FE1]/5 to-transparent" data-id="element-70" />
          <span className="text-[10px] font-medium text-[#4B9FE1] uppercase tracking-wider mb-2 relative z-10" data-id="element-71">
            Integrated
          </span>

          <div className="flex-1 w-full flex items-center justify-center relative z-10" data-id="element-72">
            <div className="w-24 h-24 rounded-full border border-[#4B9FE1]/40 bg-[#4B9FE1]/10 flex items-center justify-center relative" data-id="element-73">
              <LayersIcon className="w-6 h-6 text-[#4B9FE1]" data-id="element-74" />

              {/* Neatly arranged icons around the center */}
              <div className="absolute -top-2 -left-2 p-1 bg-[#0B1623] rounded-full border border-[#4B9FE1]/30 text-[#4B9FE1]" data-id="element-75">
                <MicroscopeIcon className="w-3 h-3" data-id="element-76" />
              </div>
              <div className="absolute -top-2 -right-2 p-1 bg-[#0B1623] rounded-full border border-[#4B9FE1]/30 text-[#4B9FE1]" data-id="element-77">
                <DatabaseIcon className="w-3 h-3" data-id="element-78" />
              </div>
              <div className="absolute -bottom-2 -left-2 p-1 bg-[#0B1623] rounded-full border border-[#4B9FE1]/30 text-[#4B9FE1]" data-id="element-79">
                <FactoryIcon className="w-3 h-3" data-id="element-80" />
              </div>
              <div className="absolute -bottom-2 -right-2 p-1 bg-[#0B1623] rounded-full border border-[#4B9FE1]/30 text-[#4B9FE1]" data-id="element-81">
                <StethoscopeIcon className="w-3 h-3" data-id="element-82" />
              </div>
            </div>
          </div>
        </motion.div>
      </div>

      <motion.p initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 1.2
    }} className="text-xs text-center text-slate-300" data-id="element-83">
        Integration reduces translational complexity.
      </motion.p>
    </div>;
}